"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRefFn = void 0;
const react_1 = require("react");
const CHECK_EMPTY = {};
const useRefFn = (fn) => {
    const ref = (0, react_1.useRef)(CHECK_EMPTY);
    if (ref.current === CHECK_EMPTY) {
        ref.current = fn();
    }
    return ref;
};
exports.useRefFn = useRefFn;
//# sourceMappingURL=index.js.map